import { combineReducers } from 'redux';
import {
	SET_BANK_LINK_REDIRECT_URI,
	SET_IS_BANK_LINK_DRAWER_MODAL_OPEN,
} from 'stash/actions/linkBank.js';

export const oauth = (state = {}, action) => {
	switch (action.type) {
		case SET_BANK_LINK_REDIRECT_URI:
			return {
				...state,
				redirectUri: action.oauthRedirectUri,
			};
		default:
			return state;
	}
};

export const BankLinkDrawerModalProps = (state = false, action) => {
	switch (action.type) {
		case SET_IS_BANK_LINK_DRAWER_MODAL_OPEN:
			return {
				...state,
				isOpen: action.isOpen,
			};
		default:
			return state;
	}
};

export default combineReducers({
	oauth,
	BankLinkDrawerModalProps,
});
